import React from "react";

const WelcomePage = ()=> {
        return (
            <h1>Here We Implement Landing Web Page</h1>
        );
}
export default WelcomePage;